import Switch from './Switch';

export * from './Switch';

export default Switch;
